import React from 'react';

/**
 * Safely render limited inline HTML (only <b> and <br/> tags) from trusted package
 * subtext data. Uses JSX elements only — no raw HTML injection — so this is XSS-safe
 * even if the source data changes.
 *
 * @param {string} html  e.g. "Download speed up to <b>300mbps</b><br/>Upload speed up to <b>50mbps</b>"
 * @returns {React.ReactNode}
 */
export const renderSubtext = (html) => {
  if (!html) return null;
  // Split on <br/> variants first
  const lines = html.split(/<br\s*\/?>/i);
  return lines.map((line, lineIdx) => {
    // Then parse <b>...</b> within each line
    const parts = line.split(/(<b>[\s\S]*?<\/b>)/i);
    return (
      <React.Fragment key={`line-${lineIdx}`}>
        {parts.map((part, partIdx) => {
          const match = part.match(/^<b>([\s\S]*?)<\/b>$/i);
          return match
            ? <b key={`bold-${lineIdx}-${partIdx}`}>{match[1]}</b>
            : <React.Fragment key={`text-${lineIdx}-${partIdx}`}>{part}</React.Fragment>;
        })}
        {lineIdx < lines.length - 1 && <br />}
      </React.Fragment>
    );
  });
};
